import React from 'react';

interface DrawingToolbarProps {
    activeTool: 'cursor' | 'trendline' | 'horizontal' | 'text';
    onToolChange: (tool: 'cursor' | 'trendline' | 'horizontal' | 'text') => void;
    onClear: () => void;
}

const DrawingToolbar: React.FC<DrawingToolbarProps> = ({ activeTool, onToolChange, onClear }) => {
    const tools = [
        { id: 'cursor', icon: '👆', label: 'Sélection' },
        { id: 'trendline', icon: '📈', label: 'Ligne de Tendance' },
        { id: 'horizontal', icon: '➖', label: 'Ligne Horizontale' },
        // { id: 'text', icon: 'T', label: 'Texte' }, // Future
    ];

    return (
        <div style={{
            position: 'absolute',
            left: '10px',
            top: '60px', /* Below header/period selector */
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            borderRadius: '8px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            display: 'flex',
            flexDirection: 'column',
            padding: '5px',
            gap: '5px',
            zIndex: 20
        }}>
            {tools.map((tool) => (
                <button
                    key={tool.id}
                    onClick={() => onToolChange(tool.id as any)}
                    title={tool.label}
                    style={{
                        background: activeTool === tool.id ? '#eff6ff' : 'transparent',
                        border: activeTool === tool.id ? '1px solid #2563eb' : '1px solid transparent',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        padding: '8px',
                        fontSize: '18px',
                        color: activeTool === tool.id ? '#2563eb' : '#4b5563',
                        transition: 'all 0.2s',
                        outline: 'none'
                    }}
                >
                    {tool.icon}
                </button>
            ))}

            <div style={{ height: '1px', background: '#e5e7eb', margin: '4px 0' }} />

            <button
                onClick={onClear}
                title="Tout effacer"
                style={{
                    background: 'transparent',
                    border: '1px solid transparent',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    padding: '8px',
                    fontSize: '18px',
                    color: '#ef4444',
                    transition: 'all 0.2s',
                    outline: 'none'
                }}
            >
                🗑️
            </button>
        </div>
    );
};

export default DrawingToolbar;
